import React from "react";
import { observer, inject } from "mobx-react";

@inject("store")
@observer
export default class Breadcrumb extends React.Component {
    constructor(props) {
        super(props);
        this.navigateToSiteUrl = this.navigateToSiteUrl.bind(this);
    }

    navigateToSiteUrl(e, node) {
        e.preventDefault();
        const navigation = this.props.store.navigation;
        navigation.navigateToSiteUrl(navigation.mainTree, node.Url, node.Name);
    }

    render() {
        const navigation = this.props.store.navigation;
        const nodes = navigation.getNodes(navigation.NodePath) || [];

        const listItems = [];
        for (const node of nodes.filter(node => node !== undefined && node.Id !== navigation.NodeId)) {
            listItems.push(<li key={node.Id}><a href={node.Url} title={node.Name} onClick={(event) => this.navigateToSiteUrl(event, node)}>{node.Name}</a></li>);
            listItems.push(<li key={node.Id + "_delimiter"} className="breadcrumb-delimiter">&gt;</li>);
        }

        return <ul>{
            listItems
        }</ul>
    }
}